import { computed, ref } from 'vue';
import { swiperModules } from './vue.js';

// Funkcja composable dla wspólnej logiki
export function useCommonLogic() {
  // Logika, która jest dostępna w każdym komponencie
  const width = computed(() => window.innerWidth);
  const activeName = ref('0');

  const returnPage = () => {
    return history.length > 2 ? history.back() : window.location.href='/';
  }

  // Zwracamy obiekt, który ma być dostępny w `setup()` komponentu
  return {
    width,
    activeName,
    returnPage,
    modules: swiperModules
  };
}
